module.exports = __webpack_public_path__ + "img/fig_rosalee_pt.32617d5b.png";